import Box from '@mui/material/Box';
import { useColors } from '../theme/ColorModeContext';

interface PropsDifficulty {
    level: number;
}

const Difficulty = (props: PropsDifficulty) => {
    const colors = useColors();
    const level = props.level;

    const dotBase = {
        height: "12px",
        width: "12px",
        backgroundColor: colors.bg.surface,
        borderRadius: "50%",
        display: "inline-block",
        marginLeft: "5px",
        transition: "all 0.2s ease",
    };

    const dotColors: Record<string, any> = {
        veryEasy: { ...dotBase, backgroundColor: colors.difficulty.veryEasy, boxShadow: `0 0 4px ${colors.difficulty.veryEasy}40` },
        easy: { ...dotBase, backgroundColor: colors.difficulty.easy, boxShadow: `0 0 4px ${colors.difficulty.easy}40` },
        medium: { ...dotBase, backgroundColor: colors.difficulty.medium, boxShadow: `0 0 4px ${colors.difficulty.medium}40` },
        hard: { ...dotBase, backgroundColor: colors.difficulty.hard, boxShadow: `0 0 4px ${colors.difficulty.hard}40` },
        veryHard: { ...dotBase, backgroundColor: colors.difficulty.veryHard, boxShadow: `0 0 4px ${colors.difficulty.veryHard}40` },
    };

    const getDotColor = (level: number) => {
        if (level <= 20) return dotColors.veryEasy;
        if (level <= 40) return dotColors.easy;
        if (level <= 60) return dotColors.medium;
        if (level <= 80) return dotColors.hard;
        return dotColors.veryHard;
    };

    const dotColor = getDotColor(level);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
           { [...Array(5)].map((e, i) =>
                (i * 20 <= level ? (
                    <span style={dotColor} key={i}></span>
                ) : (
                    <span style={dotBase} key={i}></span>
                ))
            )}
        </Box>
    );
};

export { Difficulty };
